<!--
 * @Author: yindengli
 * @Date: 2023-06-26 11:04:28
 * @LastEditTime: 2023-06-30 17:20:20
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\FaqCmp\home\SearchCmp.vue
-->
<template>
  <div class="search-cmp">
    <a-input-search placeholder="输入并搜索" :enter-button="searchange" size="large" v-model="searchCondition.keyword"
      @search="onSearch">
      <a-select v-if="showType" slot="addonBefore" class="search-type" v-model="selectedValue"
        :default-value="initValue && initValue.id" style="width: 150px" @change="handleChange">
        <a-select-option :value="0" :key="0"> 全部 </a-select-option>
        <a-select-option v-for="item in categories" :key="item.id" :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-input-search>
    <a-button v-if="isFaq && showType" type="primary" class="title-search" @click="TitleSearch">全文搜索</a-button>
    <a-button type="primary" class="title-search ai-search" @click="jumpAIPage">
      <i class="icon-search"></i>
      智能搜索
    </a-button>
  </div>
</template>

<script>
import comiMixin from "@/mixins/comiMixin.js";

export default {
  name: "search-cmp",
  props: {
    categories: Array,
    showType: {
      type: Boolean,
      default: true
    },
    initValue: Object
  },
  mixins: [comiMixin],
  data() {
    return {
      searchange: "标题搜索",
      isFaq: true,
      selectedValue: "",
      searchCondition: {
        id: "",
        keyword: "",
        byTitle: 1
      },
      // initValue:{
      //   name:"FAQ",
      //   id:-1
      // },
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.keyword) {
      this.searchCondition.keyword = JSON.parse(JSON.stringify(this.$route.params.keyword));
    }
    //获取初始化选项
    // this.initValue = JSON.parse(sessionStorage.getItem('initValue'))
    this.handleInitData();
  },
  methods: {
    TitleSearch() {
      this.searchCondition.byTitle = 0;
      this.$emit("search", JSON.parse(JSON.stringify(this.searchCondition)), true);
    },
    onSearch(value) {
      if (this.searchange == '标题搜索') {
        this.searchCondition.byTitle = 1;
      } else {
        this.searchCondition.byTitle = 0;
      }
      this.searchCondition.keyword = value;
      this.$emit("search", JSON.parse(JSON.stringify(this.searchCondition)), true);
    },
    switchSearch() {
      if (this.selectedValue == '-1') {
        this.isFaq = true
        this.searchCondition.byTitle = 1;
        this.searchange = "标题搜索"
      } else {
        this.searchange = "全文搜索"
        this.searchCondition.byTitle = 0;
        this.isFaq = false
      }
    },
    handleChange(value, option) {
      this.switchSearch();
      const key = option.data.key
      this.searchCondition.id = key;
      this.$emit("search", JSON.parse(JSON.stringify(this.searchCondition)), true);
    },
    handleInitData(id){
      this.selectedValue = id || this.initValue.id;
      this.searchCondition.id = this.selectedValue;
      this.switchSearch();
    }
  },
  computed: {
    getKeyword() {
      return this.keyword || "";
    },
  },
};
</script>
<style>
.search-type .ant-select-selection .ant-select-selection__rendered .ant-select-selection-selected-value {
  width: 100%;
}
</style>
<style scoped lang="scss">
::v-deep {
  .title-search.ant-btn-primary,
  .ant-input-group-addon .ant-btn-lg,
  .ant-input {
    border: 1px solid #027bff;
    height: 48px;
    font-size: 18px;
  }

  .ant-input-group-addon {
    border: 1px solid #027bff;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .ant-input-group-addon:first-child,
  .ant-input-search-enter-button input {
    border-right: none;
  }

  .ant-btn-primary {
    background: #007AFF;
    border-radius: 8px;
    padding: 0 30px;
  }

  .ant-select {
    color: #007AFF;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }

  .ant-select-arrow {
    color: #007AFF;
  }
}

.search-cmp {
  display: flex;
}

.title-search {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  font-size: 16px;
  margin-left: 5px;
  &.ai-search{
    background: #46C563;
    border: 1px solid #46C563;
    padding: 0 20px;
  }
}
.icon-search{
  margin-right: 10px;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: center / cover url("@/assets/imgs/search.png") no-repeat;
}

@media screen and (max-width: 1024px) {

  .search-cmp ::v-deep {
    .ant-btn-lg,
    .ant-btn-primary {
      padding: 0 6px;
      font-size: 12px;
      height: 36px;
    }

    .ant-input-group-addon .ant-select {
      width: 100px !important;
    }

    .ant-input-lg {
      height: 36px;
      padding: 4px 6px;
      font-size: 14px;
    }
  }
  .icon-search{
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
}
@media screen and (max-width: 824px) {
  
  .search-type {
    display: none;
  }
  .search-cmp ::v-deep {
    .ant-input-group-addon {
      padding: 0px;
      border: none;
    }
    .ant-input-group .ant-input {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
  }
  .icon-search{
    width: 12px;
    height: 12px;
    margin-right: 3px;
  }
}
</style>